import EventEmitter from '../../Utils/EventEmitter'

export default class Meter {

    constructor(audioContext, destination, stream, callback) {
        //super();
        //window.AudioContext = window.AudioContext || window.webkitAudioContext;        
        this.context = audioContext;
        this.destination = destination;
        this.stream = stream;
        this.node = new AudioWorkletNode(this.context, 'audio-volume');
        this.node.port.onmessage = event => {
            if (event.data.volume) {      
                callback(event.data.volume * 100);
            }
        }
        this.start();
    }

    start() {
        this.started = true;
        this.source = this.context.createMediaStreamSource(this.stream);
        this.source.connect(this.node).connect(this.destination);
        this.node.port.postMessage({
            status: 'run'
        });
    }
    
    stop() {
        if (this.started && this.node) {
            this.source.disconnect();
            this.source = null;
            this.node.port.postMessage({
                status: 'stop'
            });
        }
        this.started = false;
    }

}